import { render, staticRenderFns } from "./BasePrimaryButton.vue?vue&type=template&id=daec3b1a&scoped=true"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./BasePrimaryButton.vue?vue&type=style&index=0&id=daec3b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daec3b1a",
  null
  
)

export default component.exports